// src/pages/QnAList.tsx
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

import icon from '../../assets/community.svg';
import next from '../../assets/next.svg';
import clip from '../../assets/clip.svg';
import fileIcon from '../../assets/fileIcon.svg';
import closeIcon from '../../assets/closeIcon.svg';

interface QnA {
  _id: string;
  user: string;
  category: string;
  title: string;
  content: string;
  answer: string;
  createdAt: string;
  updatedAt: string;
}

const QnAList: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [qnaList, setQnAList] = useState<QnA[]>([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(3);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const getCategoryKorean = (category: string) => {
    const categoryMap: { [key: string]: string } = {
      general: '일반 문의',
      technical: '기술 문의',
      bug: '버그 신고',
      feature: '기능 요청',
      account: '계정 문의',
    };
    return categoryMap[category] || category;
  };

  const fetchQnAList = async () => {
    if (!hasMore || loading) return;
    try {
      setLoading(true);

      const response = await axios.get('/api/qna/list', {
        params: { offset, limit, userRole: user?.role },
      });

      const { data, hasMore: more, nextOffset } = response.data;
      setQnAList(prev => [...prev, ...data]);
      setOffset(nextOffset);
      setHasMore(more);

      if (limit !== 5) setLimit(5);
    } catch (error) {
      console.error('QnA 불러오기 오류:', error);
    } finally {
      setLoading(false);
    }
  };

  // 삭제된 QnA ID를 URL에서 감지하여 리스트에서 제거
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const deletedId = urlParams.get('deleted');
    if (deletedId) {
      setQnAList(prev => prev.filter(qna => qna._id !== deletedId));
      // URL에서 deleted 파라미터 제거
      const newSearch = new URLSearchParams(location.search);
      newSearch.delete('deleted');
      const newUrl = location.pathname + (newSearch.toString() ? '?' + newSearch.toString() : '');
      navigate(newUrl, { replace: true });
    }
  }, [location.search, navigate]);

  useEffect(() => {
    fetchQnAList();
  }, []);

  console.log(qnaList, '===============qna');

  return (
    <div className="qna-container">
      <div className="page-header">
        <img src={icon} alt="Mind Thermometer Icon" className="page-header__icon" />
        <h2 className="page-header__title">문의 내역</h2>
        <p>이전 문의사항을 확인하세요.</p>
      </div>

      <div className="qna-list">
        <div className="qna-list__header">
          <Link to="/setting/qna/new" style={{ textDecoration: 'none' }}>
            <button>문의하기</button>
          </Link>
        </div>

        <div className="qna-card">
          {qnaList.map(qna => (
            <div
              className="qna-card__item"
              key={qna._id}
              onClick={() => navigate(`/setting/qna/${qna._id}`)}
            >
              <div>
                <span className="qna-card__category">{getCategoryKorean(qna.category)}</span>

                <h3 className="qna-card__title">{qna.title}</h3>
                <p className="qna-card__date">{moment(qna.createdAt).format('YYYY-MM-DD')}</p>
              </div>

              <p className="qna-card__answer">
                {qna.answer ? (
                  <span className="qna-card__answer-done">
                    답변 완료
                    <img src={next} alt="이동" />
                  </span>
                ) : (
                  <span className="qna-card__answer-waiting">
                    답변 대기
                    <img src={next} alt="이동" />
                  </span>
                )}
              </p>
            </div>
          ))}
        </div>

        {loading && <p className="loading-text">불러오는 중...</p>}

        {hasMore && !loading && (
          <button className="qna-list__load-more-btn" onClick={fetchQnAList}>
            더보기
          </button>
        )}

        {!hasMore && qnaList.length > 0 && (
          <p className="qna-list__no-more-text">모든 문의 내역을 확인했습니다.</p>
        )}
        {qnaList.length === 0 && <p className="qna-list__no-more-text">문의 내역이 없습니다.</p>}
      </div>
    </div>
  );
};

export default QnAList;
